import * as React from 'react';
import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import { RouterParamsState } from '../SetRouteParams/reducer';
import Theater from '../Theater';
import { DriveItemListOrigin } from '../DriveItemListPage/constants';
import RoutesUtils from '../../utils/routes';

export interface TheaterPageProps {
	routerParamsHistory: RouterParamsState[];
}

class TheaterPage extends React.Component<TheaterPageProps, {}> {
	render() {
		const { routerParamsHistory } = this.props;
		const { driveItemId } = routerParamsHistory[routerParamsHistory.length - 1].params;
		const itemId = parseInt(driveItemId, 10);
		return (
			<Theater
				origin={DriveItemListOrigin.Folder}
				sliderKey={''}
				driveItemId={itemId}
				driveItemIds={[itemId]}
				isLoading={false}
				leavePage={this.leavePage}
			/>
		);
	}

	leavePage(): void {
		window.location.hash = `${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, null)}`;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { routerParamsHistory } = state;
	return { routerParamsHistory };
};

export default connect(mapStateToProps)(TheaterPage);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/TheaterPage/index.tsx